module.exports = __webpack_public_path__ + "static/img/bg.a2fa772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/bg.png
// module id = 9DJJ
// module chunks = 44